<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi"
                                           ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryAbnormalArrivalProcessResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" inlineActionsDisabled
                                      :query-api="$_emWorkflowListMixin_queryApi"
                                      :ref="modelName+'Table'" editDisable with-custom-row-actions-first-column>

                                <template slot="left-header">
                                    <em-button type="search"
                                               v-if="pathType === 'todo'"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :customLabel="isClaim ? '认领' : '待办'"
                                               :custom-icon="'fa ' + (isClaim ? 'fa-toggle-on' : 'fa-toggle-off')"
                                               :busy="emWorkflowListLoading"
                                               show-name
                                               @click="switchClaim">
                                    </em-button>
                                    <em-button type="search"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               customLabel="一键转交"
                                               :disabled="notSelected"
                                               show-name
                                               @click="switchShow">
                                    </em-button>
                                </template>
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <em-button type="task"
                                               :busy="claimLoading"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :custom-label="isClaim ? '认领' : '处理'"
                                               @click="handleExecute(customRowScope.row)">
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="一键转交" :visible.sync="visible" width="30%" @close="handelCLose" z-index="500">
            <el-form label-width="auto">
                <el-form-item label="发货方" label-position="top" class="ml-0">
                    <el-input v-model="form.consignor" placeholder="发货方"></el-input>
                </el-form-item>
                <el-form-item label="收货方" label-position="top" class="ml-0">
                    <el-input v-model="form.consignee" placeholder="收货方"></el-input>
                </el-form-item>
                <el-form-item label="收货地址" label-position="top" class="ml-0">
                    <el-input v-model="form.consigneeAddress" placeholder="收货地址"></el-input>
                </el-form-item>
                <el-form-item label="收货联系人" label-position="top" class="ml-0">
                    <el-input v-model="form.contact" placeholder="收货联系人"></el-input>
                </el-form-item>
                <el-form-item label="收货联系电话" label-position="top" class="ml-0">
                    <el-input v-model="form.contactPhone" placeholder="收货联系电话"></el-input>
                </el-form-item>
                <el-form-item label="实际配送时间" label-position="top" class="ml-0">
                    <el-date-picker
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="form.packageActualTime"
                            type="datetime"
                            placeholder="实际配送时间" class="w-100">
                    </el-date-picker>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSubmit" id="submit" :disabled="!form.consignor ||
                !form.consignee || !form.consigneeAddress || !form.contact || !form.contactPhone || !form.packageActualTime || buttonDisabled"
                >确 定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// Author Lin
// Date 2021-05-16 19:04:44
import emWorkflowListMixin from "@/mixin/em/workflow/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import EmCommonApi from "@/mixin/em/common/api";
import emCustomVuexMixin from "@/mixin/em/customVuex";

export default {
    name: "sithMesInventoryAbnormalArrivalProcessWorkflowListView",
    mixins: [emWorkflowListMixin, emCommonGotoMixin, EmCommonApi, emCustomVuexMixin],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        $_emRouterHelperMixin_pathType() {
            return this.isClaim ? 'claim' : this.$route.query.pathType;
        },
        pathType() {
            return this.$route.query.pathType;
        },
    },
    watch: {
        pathType() {
            this.isClaim = false;
        }
    },
    data() {
        return {
            isClaim: false,
            claimLoading: false,
            visible: false,
            buttonDisabled: false,
            form: {
                poItemIds: [],
                ids: [],
            },
        }
    },
    methods: {
        switchClaim() {
            this.isClaim = !this.isClaim;
        },
        switchShow() {
            let flag = true;
            for (let i = 0; i < this.selectedItems.length; i++) {
                let item = this.selectedItems[i];
                if (!item.poItemId) {
                    this.$message.error(item.workOrderCode + "该流程没有填写PO数据，请选择有PO数据转交");
                    flag = false;
                } else if (!item.poNumber) {
                    this.$message.error(item.workOrderCode + "该流程PO已被删除，请手动给该异常到货流程添加转交任务");
                    flag = false;
                }
                if (flag === false) {
                    break;
                }
            }
            this.visible = flag;
        },
        handleExecute(row) {
            console.log(row)
            if (this.isClaim) {
                if (row.workflowTask && row.workflowTask.processDefinitionKey) {
                    this.claimLoading = true;
                    this.$store.dispatch('api/post', {
                        url: process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryAbnormalArrivalProcess/claimTask",
                        data: {
                            processDefinitionKey: row.workflowTask.processDefinitionKey,
                            businessKeyList: [row.id]
                        }
                    }).then(() => {
                        this.claimLoading = false;
                        this.$message.success("认领成功");
                        this.$_emWorkflowListMixin_init();
                    });
                }
            } else {
                this.$_emWorkflowListMixin_handleApprove(row);
            }
        },
        handleSubmit() {
            this.buttonDisabled = true;
            this.selectedItems.forEach(item => {
                this.form.poItemIds.push(item.poItemId)
                this.form.ids.push(item.id)
            })
            let bzUrl = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryDeliveryTask")}/generateDeliveryTaskByPoItemId`
            this.$_emApiMixin_post(bzUrl, this.form).then(response => {
                if (response.status === 200) {
                    this.$message.success("一件转交提交成功");
                    this.visible = false;
                    this.buttonDisabled = false;
                    this.$router.push({name: 'sithMesInventoryPartsDeliveryTaskList'});
                } else {
                    this.buttonDisabled = false;
                    this.$message.error(response.message);
                }
            }).finally(() => {
                this.buttonDisabled = false
            })
        },
        handelCLose() {
            this.form = {
                poItemIds: [],
                ids: []}
            },
        },
    mounted() {
        if (this.$route.query.toClaim) {
            this.isClaim = true;
        }
        if (this.$route.query.hasOwnProperty('processId')) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.processId);
            this.$refs.emListFilter.doQuery();
        }
    },
};
</script>
